module.exports = __webpack_public_path__ + "img/resourcesbg3.4d3e4cc0.png";